const intervalCheckPromise = async ({
  checkedValue,
  ms,
}: {
  checkedValue: boolean;
  ms: number;
}): Promise<void> =>
  await new Promise((resolve) => {
    if (checkedValue) {
      resolve();
    } else {
      setInterval(() => {
        if (checkedValue) {
          resolve();
        }
      }, ms);
    }
  });

export { intervalCheckPromise };
